/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const HamburgerMenuStrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M0.699951 6C0.699951 5.72386 0.923809 5.5 1.19995 5.5H22.8C23.0761 5.5 23.3 5.72386 23.3 6C23.3 6.27614 23.0761 6.5 22.8 6.5H1.19995C0.923809 6.5 0.699951 6.27614 0.699951 6ZM0.699951 12C0.699951 11.7239 0.923809 11.5 1.19995 11.5H22.8C23.0761 11.5 23.3 11.7239 23.3 12C23.3 12.2761 23.0761 12.5 22.8 12.5H1.19995C0.923809 12.5 0.699951 12.2761 0.699951 12ZM1.19995 17.5C0.923809 17.5 0.699951 17.7239 0.699951 18C0.699951 18.2761 0.923809 18.5 1.19995 18.5H22.8C23.0761 18.5 23.3 18.2761 23.3 18C23.3 17.7239 23.0761 17.5 22.8 17.5H1.19995Z"
          fill="#0A0A0A"
          fillRule="evenodd"
          clipRule="evenodd"
        />
      </svg>
    </Icon>
  );
});

export { HamburgerMenuStrokeIcon };
